import type { Schema } from '@cli-types/core-engine/schema.js'
import { hasGeneratedSchemaTitleField } from './has-generated-schema-title-field.js'

export function collectMissingGeneratedSchemaTitleErrors(
  schema: Schema,
  schemaKind: 'Entity' | 'Single',
  errors: string[]
): void {
  if (hasGeneratedSchemaTitleField(schema.fields || [])) return
  errors.push(
    `${schemaKind} schema "${schema.name}" must define a text-compatible field named "title".`
  )
}
